
import Blog from '~/components/Common/Blog'
import BlogTextColor from '~/components/Common/Blog/BlogTextColor'

export default {
    name: 'FUTURES',
    components: { Blog, BlogTextColor },
}
